/**
 * Re-renders the standalone collection products count when facets update.
 * Facet AJAX only replaces the main collection section, so this section
 * would otherwise keep the unfiltered total.
 */
(function () {
  const SECTION_SELECTOR = ".shopify-section--collection-products-count";
  let abortController = null;
  let realTotal = 0;

  function applyRealCount(total) {
    const count = Number(total);
    if (!count) {
      return;
    }

    realTotal = count;
    const node = getCountSection()?.querySelector(
      ".collection-toolbar__products-count",
    );
    const template = node?.getAttribute("data-count-template");
    if (!node || !template || !template.includes("987654")) {
      return;
    }

    node.textContent = template.replace("987654", String(count));
  }

  function getCountSection() {
    return document.querySelector(SECTION_SELECTOR);
  }

  function applySectionHtml(html) {
    const section = getCountSection();
    if (!section || !html) {
      return false;
    }

    const sectionId = section.id.replace("shopify-section-", "");
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newSection =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.querySelector(SECTION_SELECTOR) ||
      doc.querySelector(".shopify-section");

    if (!newSection) {
      return false;
    }

    section.replaceChildren(
      ...document.importNode(newSection, true).childNodes,
    );
    if (realTotal > 0) {
      applyRealCount(realTotal);
    }
    return true;
  }

  document.addEventListener("collection-products-count:sync", (event) => {
    applyRealCount(event.detail?.total);
  });

  document.addEventListener("facet:section-html", (event) => {
    const section = getCountSection();
    const sectionId = section?.id.replace("shopify-section-", "");

    if (!sectionId || event.detail?.sectionId !== sectionId) {
      return;
    }

    if (abortController) {
      abortController.abort();
      abortController = null;
    }

    applySectionHtml(event.detail.html);
  });
})();
